export default "__VITE_ASSET__38e49a72__"